/// <reference path="../_references.ts"/>

/**
 * From: https://github.com/toksfifo/bottom-drawer
 */

module App.Helpers {
	export type BottomDrawerItem = {
		text: string;
		icon: string;
		fn?: () => void;
		recursive?: boolean;
	}

	export class BottomDrawerService {
		public isOpen: boolean = false;
		public closeable: boolean = true;

		options: Array<BottomDrawerItem> = [];

		hideCancel: boolean = false;

		constructor() {
			return this;
		}

		public open(newOptions: Array<BottomDrawerItem>, boolHideCancel: boolean, closeable: boolean = true) {
			this.options = newOptions;
			this.hideCancel = boolHideCancel || false;
			this.isOpen = true;
			this.closeable = closeable;
		}

		public close() {
			this.isOpen = false;
		}

		static Factory() {
			let instance = () => new BottomDrawerService();

			instance.$inject = [];

			return instance;
		}
	}
}
